import React, { HtmlHTMLAttributes, useEffect, FC } from 'react';
import './Menu.css'
import MenuScroll from '../MenuScroll/MenuScroll';


const Menu: React.FC = () => {





    return (
        <div className='menu'>
            <div id='title'>mY memory</div>
            <MenuScroll />
        </div>
    )
}

export default Menu;